// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2BHxK","rootSuccess":"CompleteLink_rootSuccess__EuhaD","rootFailure":"CompleteLink_rootFailure__2PF_H","isDisabled":"CompleteLink_isDisabled__MGt3M"};